var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBdouinLogoFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5255",
    "data-name": "Group 5255",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 278.694,
    height: 251.023,
    viewBox: "0 0 278.694 251.023",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1430",
    "data-name": "Rectangle 1430",
    width: 278.694,
    height: 251.023,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5256",
    "data-name": "Group 5256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5255-2",
    "data-name": "Group 5255",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8926",
    "data-name": "Path 8926",
    d: "M37.376,309.587c6.456-2.694,16.12-7.072,16.12-19.982,0-13.582-12.81-20.767-30.026-20.767H.993c-.663,0-.993.337-.993.674s.828.673,1.159,1.01l4.965,3.256a3.373,3.373,0,0,1,1.49,3.143L9.4,344.947a3.374,3.374,0,0,1-1.49,3.143l-4.965,3.255c-.331.449-1.159.674-1.159,1.011s.331.674.993.674H28.769c13.574,0,25.059-7.746,25.059-24.023,0-12.46-10-17.175-16.452-19.42m-10.1,37.83H22.147v-34.35H24.63c8.111,0,11.587,4.153,11.587,15.155,0,15.154-1.655,19.2-8.939,19.2M24.63,307.454H22.147v-33H24.63c8.111,0,11.587,3.7,11.587,15.155,0,13.471-3.476,17.849-11.587,17.849",
    transform: "translate(0 -102.058)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5258",
    "data-name": "Group 5258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5257",
    "data-name": "Group 5257",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8927",
    "data-name": "Path 8927",
    d: "M195.208,303.774c-10.574.644-19.108,7.574-17.764,29.647,1.686,27.676,10.983,33.3,21.558,32.652,10.739-.655,19.286-7.36,17.6-35.036-1.344-22.073-10.656-27.916-21.4-27.262m3.5,57.48c-4.3.262-6.841-3.407-8.376-28.618-1.187-19.5.873-23.783,5.169-24.044,4.461-.272,7.027,3.733,8.214,23.23,1.535,25.21-.546,29.161-5.007,29.432m71,3.785-5.132-3.929a1.759,1.759,0,0,1-.165-1.011V304.533c0-.449-.166-.673-.828-.673H247.695c-.5,0-.993.112-.993.449,0,.225.331.561.828.9l4.8,3.143a.954.954,0,0,1,.5.9v43.218c0,5.5-3.477,8.981-7.449,8.981-4.3,0-6.456-2.245-6.456-6.511v-46.83c0-.449-.331-.673-.828-.673H222.2c-.5,0-.993.112-.993.449,0,.225.331.561.663.9l4.966,3.143a.955.955,0,0,1,.5.9v42c0,7.633,4.469,11.45,14.07,11.45,5.3,0,8.277-2.021,11.091-4.266h.331v3.817c0,.225.5.449,1.158.449h15.395c.663,0,1.159-.112,1.159-.449,0-.225-.331-.561-.828-.786m25.68,0-5.132-3.929c-.331-.225-.331-.561-.331-1.011V304.533c0-.449-.331-.673-.828-.673l-18.422.149c-.5,0-.993.112-.993.449,0,.225.331.561.662.9l4.966,3.143a.955.955,0,0,1,.5.9l2.531,50.7c0,.449,0,.786-.331,1.011l-5.132,3.929c-.331.225-.662.561-.662.786,0,.336.5.449.993.449h21.85c.662,0,.993-.112.993-.449,0-.225-.331-.561-.662-.786m49.951,0-5.132-3.929c-.331-.225-.331-.561-.331-1.011l1.042-44.79c0-7.521-5.463-11.45-13.74-11.45-5.628,0-8.442,1.8-11.422,3.929h-.331v-3.256c0-.449-.166-.673-.828-.673H298.71c-.5,0-.993.112-.993.449,0,.225.331.561.662.9l4.966,3.143a.955.955,0,0,1,.5.9V360.1c0,.449,0,.786-.331,1.011l-5.132,3.929c-.5.225-.662.561-.662.786,0,.336.331.449.993.449h21.851c.5,0,.993-.112.993-.449,0-.225-.331-.561-.828-.786l-5.132-3.929a1.753,1.753,0,0,1-.166-1.011V318.453c0-6.062,4.3-9.767,8.277-9.767,3.807,0,5.628,2.245,5.628,6.511l-1.042,44.9c0,.449,0,.786-.331,1.011l-5.132,3.929c-.331.225-.662.561-.662.786,0,.336.331.449.993.449h21.85c.5,0,.993-.112.993-.449,0-.225-.331-.561-.662-.786",
    transform: "translate(-67.309 -115.302)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5260",
    "data-name": "Group 5260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5259",
    "data-name": "Group 5259",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8928",
    "data-name": "Path 8928",
    d: "M339.108,266.331a8.71,8.71,0,1,0,8.71,8.71,8.71,8.71,0,0,0-8.71-8.71",
    transform: "translate(-125.427 -101.106)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5262",
    "data-name": "Group 5262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5261",
    "data-name": "Group 5261",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8929",
    "data-name": "Path 8929",
    d: "M111.976,269.171H87.892c-.662,0-1.007.336-1.022.672s.8.672,1.115,1.009l4.825,3.249a3.221,3.221,0,0,1,1.354,3.138l.489,67.9a3.525,3.525,0,0,1-1.625,3.137l-5.106,3.25c-.35.448-1.188.672-1.2,1.008s.3.672.964.672h20.659c16.719,0,26.98-7.619,28.56-44.147,1.254-29.021-8.208-39.889-24.927-39.889m11.353,39.889c-1.482,34.287-7.791,38.545-14.247,38.545H106.1l3.148-72.831h2.98c6.456,0,12.4,4.258,11.1,34.287",
    transform: "translate(-32.921 -102.184)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5264",
    "data-name": "Group 5264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5263",
    "data-name": "Group 5263",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8930",
    "data-name": "Path 8930",
    d: "M249.335,62.98c-1.416-12.87-11.188-24.08-26.95-27.208C217.487,17.62,196.4,3.908,171.124,4.011c-29.357.119-45.253,11.5-50.42,27.323a30.56,30.56,0,0,0-9.181,10.328c-23.939,1.5-42.761,16.9-42.761,35.677a27.95,27.95,0,0,0,.9,7.03C66.094,87.006,64,90.2,64,93.642c0,9.045,14.432,16.378,32.235,16.378h.089a58.506,58.506,0,0,0,19.043,3.128,60.3,60.3,0,0,0,10.192-.869c9.7,4.978,22.611,8.016,36.783,8.016a85.242,85.242,0,0,0,32.777-6.148c.88.027,1.767.043,2.659.043a75.716,75.716,0,0,0,25.8-4.328,42.892,42.892,0,0,0,13.36,2.094c18.543,0,33.575-11.365,33.575-25.386,0-10.707-8.771-19.859-21.173-23.59",
    transform: "translate(-24.295 -1.522)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5266",
    "data-name": "Group 5266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5265",
    "data-name": "Group 5265",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8931",
    "data-name": "Path 8931",
    d: "M249.962,60.853c-3.127-24.865-19.877-28.364-26.651-28.587-35.138-54.94-91.27-23.078-91.27-23.078-6.849,4.913-2.829,4.616,3.294,2.011,48.49-18.025,77.182,15.271,82.615,21.365-6.253.3-16.9,7.817-14.939,9.668,30.066-18.887,41.595,11.094,41.591,18.026-4.467,0-10.869,1.712-12.06,4.616,19.8-6.7,41.242,7.3,31.118,29.629s-43.625,13.7-48.985,7.3c-1.117-.6-3.276-.6,1.638,4.764-9.082,3.573-18.313,3.127-23.674,2.978-40.945,14.145-61.194,2.382-68.638-1.042-15.633,3.573-29.778-1.34-33.8-2.531,2.084-.893,5.658-3.276,5.36-5.956-5.211,5.509-13.7,4.467-17.122,3.871C52.385,99.267,64.892,85.569,68.466,82c-2.829-42.583,40.051-40.2,47.943-39.456-4.318-2.978-2.233-1.489-7-3.722,7.952-11.277,21.938-13.148,22.741-13.246a36.074,36.074,0,0,1,.784-3.578c-18.76,4.764-25.46,12.953-28.542,16.167C55.3,40.845,62.75,75.179,64.3,81.847c-22.81,21.513,10.634,29.026,24.716,27.247,7.742,3.871,27.4,4.616,33.635,3.665,34.662,20.01,67.25,3.59,71.481,1.249,12.2,2.852,29.848-3.148,29.182-3.573,0,0,37.371,9.678,47.794-14.293s-13.251-34.394-21.142-35.287M132.19,25.566l-.039,0c0,.1.039,0,.039,0",
    transform: "translate(-21.467 0)",
    fill: "#0f0e0b",
    fillRule: "evenodd"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5268",
    "data-name": "Group 5268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5267",
    "data-name": "Group 5267",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8932",
    "data-name": "Path 8932",
    d: "M157.049,191.827a5.6,5.6,0,0,0-7.242,3.216L138.532,224.33a5.6,5.6,0,1,0,10.458,4.027l11.275-29.287a5.6,5.6,0,0,0-3.215-7.243",
    transform: "translate(-52.448 -72.68)",
    fill: "#97d6f8",
    fillRule: "evenodd"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5270",
    "data-name": "Group 5270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5269",
    "data-name": "Group 5269",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8933",
    "data-name": "Path 8933",
    d: "M240.4,221.334c-2.888-1.112-6.875.179-7.987,3.067l-11.275,29.287c-1.112,2.888,1.072,6.28,3.96,7.392a5.6,5.6,0,0,0,7.242-3.216l11.275-29.287a5.6,5.6,0,0,0-3.215-7.243",
    transform: "translate(-83.839 -83.873)",
    fill: "#97d6f8",
    fillRule: "evenodd"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5272",
    "data-name": "Group 5272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5271",
    "data-name": "Group 5271",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8934",
    "data-name": "Path 8934",
    d: "M300.929,188.831a3.854,3.854,0,0,0-4.988,2.223L288.176,211.3a3.861,3.861,0,1,0,7.2,2.784l7.765-20.242a3.878,3.878,0,0,0-2.215-5.006",
    transform: "translate(-109.301 -71.586)",
    fill: "#97d6f8",
    fillRule: "evenodd"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5274",
    "data-name": "Group 5274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5273",
    "data-name": "Group 5273",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8935",
    "data-name": "Path 8935",
    d: "M332.609,208.751a3.854,3.854,0,0,0-4.988,2.223l-7.765,20.242a3.861,3.861,0,1,0,7.2,2.784l7.765-20.242a3.878,3.878,0,0,0-2.215-5.006",
    transform: "translate(-121.327 -79.149)",
    fill: "#97d6f8",
    fillRule: "evenodd"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5276",
    "data-name": "Group 5276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5275",
    "data-name": "Group 5275",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8936",
    "data-name": "Path 8936",
    d: "M107.8,191.927a3.526,3.526,0,0,0-4.557,2.022l-7.093,18.412a3.525,3.525,0,0,0,6.58,2.532l7.093-18.412a3.522,3.522,0,0,0-2.023-4.554",
    transform: "translate(-36.413 -72.771)",
    fill: "#97d6f8",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBdouinLogoFull);
export default __webpack_public_path__ + "static/media/bdouin-logo-full.bebcb9c9.svg";
export { ForwardRef as ReactComponent };